import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { formatDateTime } from '../utils/date';

/**
 * Nhãn bản phát hành dạng ddmmyy (vd 051026) lấy từ thời điểm build.
 *
 * Cố ý ngắn: footer là chỗ khách hàng nhìn thấy, chuỗi SHA trần ở đó vừa xấu
 * vừa vô nghĩa với họ. SHA đầy đủ nằm trong tooltip, đủ để tra ngược GitHub khi
 * cần xác định production đang chạy commit nào.
 */
function buildLabel(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  return `${dd}${mm}${yy}`;
}

/** Chân trang: tên công ty + nhãn bản phát hành. */
export function AppFooter(): JSX.Element {
  const label = buildLabel(__BUILD_TIME__);
  const sha = __BUILD_SHA__;
  const shortSha = sha === 'dev' ? 'dev' : sha.slice(0, 8);
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 4 }}>
      <Divider />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        spacing={1}
        sx={{ pt: 1.5, pb: 1, color: 'text.secondary' }}
      >
        <Typography variant="caption">Alliance ITSC © {year}</Typography>
        <Tooltip title={`Bản ${shortSha} · ${formatDateTime(__BUILD_TIME__)}`}>
          <Typography variant="caption" data-testid="build-label" sx={{ cursor: 'help' }}>
            {label}
          </Typography>
        </Tooltip>
      </Stack>
    </Box>
  );
}
